import * as yup from 'yup'

export const getBalanceTransactionSchema = (
  __: (key: string) => string,
  remaining: {
    voucher?: number
    voucher_tax?: number
    debt_disbursement?: number
    different?: number
  } = {}
) => {
  return yup
    .object()
    .shape({
      company_id: yup.string().required(__('Company is required')),
      creator: yup.string().required(__('Creator is required')),
      file: yup.mixed().required(__('File is required')),
      voucher: yup
        .number()
        .typeError(__('Voucher must be a number'))
        .min(0, __('Voucher cannot be less than 0'))
        .max(remaining.voucher ?? Infinity, __('Voucher cannot exceed remaining')),
      voucher_tax: yup
        .number()
        .typeError(__('Voucher Tax must be a number'))
        .min(0, __('Voucher Tax cannot be less than 0'))
        .max(remaining.voucher_tax ?? Infinity, __('Voucher Tax cannot exceed remaining')),
      debt_disbursement: yup
        .number()
        .typeError(__('Debt Disbursement must be a number'))
        .min(0, __('Debt Disbursement cannot be less than 0'))
        .max(remaining.debt_disbursement ?? Infinity, __('Debt Disbursement cannot exceed remaining')),
      different: yup
        .number()
        .typeError(__('Different must be a number'))
        .min(0, __('Different cannot be less than 0'))
        .max(remaining.different ?? Infinity, __('Different cannot exceed remaining'))
    })
    .test('at-least-one-value', __('At least one value must be greater than 0'), function (values) {
      const { voucher, voucher_tax, debt_disbursement, different } = values

      const hasValue = [voucher, voucher_tax, debt_disbursement, different].some(
        val => val !== undefined && val !== null && Number(val) >= 0
      )

      if (!hasValue) {
        return this.createError({
          path: 'voucher',
          message: __(
            'At least one of Voucher, Voucher Tax, Debt Disbursement, or Different must have a value greater than 0'
          )
        })
      }

      return true
    })
}

export const getBalanceTransactionEditSchema = (
  __: (key: string) => string,
  remaining: {
    voucher?: number
    voucher_tax?: number
    debt_disbursement?: number
    different?: number
  } = {}
) => {
  return yup.object().shape({
    voucher: yup
      .number()
      .typeError(__('Voucher must be a number'))
      .min(0, __('Voucher cannot be less than 0'))
      .max(remaining.voucher ?? Infinity, __('Voucher cannot exceed remaining')),
    voucher_tax: yup
      .number()
      .typeError(__('Voucher Tax must be a number'))
      .min(0, __('Voucher Tax cannot be less than 0'))
      .max(remaining.voucher_tax ?? Infinity, __('Voucher Tax cannot exceed remaining')),
    debt_disbursement: yup
      .number()
      .typeError(__('Debt Disbursement must be a number'))
      .min(0, __('Debt Disbursement cannot be less than 0'))
      .max(remaining.debt_disbursement ?? Infinity, __('Debt Disbursement cannot exceed remaining')),
    different: yup
      .number()
      .typeError(__('Different must be a number'))
      .min(0, __('Different cannot be less than 0'))
      .max(remaining.different ?? Infinity, __('Different cannot exceed remaining'))
  })
}
